import { render, staticRenderFns } from "./task-last-done.vue?vue&type=template&id=53441561&scoped=true"
import script from "./task-last-done.vue?vue&type=script&lang=ts"
export * from "./task-last-done.vue?vue&type=script&lang=ts"
import style0 from "./task-last-done.vue?vue&type=style&index=0&id=53441561&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53441561",
  null
  
)

export default component.exports